import { useState } from "react";
import { MailCheck } from "lucide-react";
import { AuthLink, AuthShell } from "@/components/account/AuthShell";
import { Field, FormError, SubmitButton } from "@/components/account/Field";
import { accountApi, errorMessage } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await accountApi.post("/account/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err, "Inserisci un'email valida."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="account-forgot-page" lines={["Password", "dimenticata?"]} kicker="Succede anche ai migliori">
      {sent ? (
        <div className="space-y-6" data-testid="account-forgot-success">
          <MailCheck className="h-10 w-10 text-acid" />
          <p className="font-display text-2xl font-black uppercase leading-tight">Controlla la posta.</p>
          <p className="text-bone/70">Se esiste un account con <span className="text-bone">{email}</span>, ti ho inviato un link per scegliere una nuova password. Vale 1 ora.</p>
          <AuthLink to="/account/accedi" testid="account-forgot-back-login">Torna all&apos;accesso</AuthLink>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="account-forgot-form">
          <p className="text-bone/70">Scrivi l&apos;email del tuo account: ti mando un link per reimpostare la password.</p>
          <Field label="Email" required type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} testid="account-forgot-email-input" />
          <FormError error={error} testid="account-forgot-error" />
          <SubmitButton loading={loading} testid="account-forgot-submit-button" loadingText="Invio…">Invia il link</SubmitButton>
          <p className="border-t border-line pt-6 text-sm text-bone/70">
            Ti sei ricordato? <AuthLink to="/account/accedi" testid="account-forgot-login-link">Accedi</AuthLink>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
